import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/images/subscription-review.png'
import _imports_1 from '../../../../assets/icons/yellow-pound.png'
import _imports_2 from '../../../../assets/images/welcome-homeowners.png'


const _withScopeId = n => (_pushScopeId("data-v-5b5f42d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subscription_plan" }
const _hoisted_2 = { class: "left__block" }
const _hoisted_3 = { class: "subscription__product" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subscription__product__name" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Iknowa Workstation"),
  /*#__PURE__*/_createElementVNode("p", null, "(Limited Company)")
], -1))
const _hoisted_5 = { class: "subscription__product__price" }
const _hoisted_6 = { class: "add__member" }
const _hoisted_7 = { class: "add__total__member" }
const _hoisted_8 = { class: "subscription__product total__product__price" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subscription__product__name" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Members fee")
], -1))
const _hoisted_10 = { class: "subscription__product__price" }
const _hoisted_11 = { class: "subscription__product total__product__price" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subscription__product__name" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Sub total"),
  /*#__PURE__*/_createElementVNode("p", null, "VAT (20%)")
], -1))
const _hoisted_13 = { class: "subscription__product__price" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "£1.50", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subscription__product total__product__price" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "subscription__product__name" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Due today"),
    /*#__PURE__*/_createElementVNode("p", null, "Billed monthly after 14 days")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "subscription__product__price" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "£0.00"),
    /*#__PURE__*/_createElementVNode("p", null, "£8.98")
  ])
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subscription__product__note" }, [
  /*#__PURE__*/_createElementVNode("p", null, " After your 14 day trial ends, you will be charged £8.98 monthly, starting [DD/MM/YYYY]. Cancel anytime. ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right__block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "right__block__img__1" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "right__block__img__2" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "right__block__img__3" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))
const _hoisted_18 = { class: "modal_centertext" }
const _hoisted_19 = { class: "modal_card_list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Property overview "),
  /*#__PURE__*/_createElementVNode("text", null, " (inc. energy efficiency)")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Record or raise projects to be approved ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Invite your landlord or property manager ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Store & manage key documents (100MB) ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" From £6.39* p/month, for a verified workstation "),
    /*#__PURE__*/_createElementVNode("text", null, " (option to add 3 properties & includes 100GB storage)")
  ])
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, " From £6.39* per additional team member ")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Create Workstation"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_commonDialog = _resolveComponent("commonDialog")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return ($setup.isShowSubscriptionPlan)
    ? (_openBlock(), _createBlock(_component_commonDialog, {
        key: 0,
        modelValue: $setup.isShowHomeownersWelcome,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.isShowHomeownersWelcome) = $event)),
        HeaderTittle: "Subscription Plan",
        onClickBackButton: $setup.onClickToggleHomeownerWelcome,
        class: "subscription__dialog"
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h5", null, "£" + _toDisplayString($setup.selectedPlanPrice), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", null, [
                  _createTextVNode("Add members "),
                  _createVNode(_component_v_icon, { icon: "mdi-information" })
                ]),
                _createElementVNode("span", null, "£" + _toDisplayString($setup.membershipPrice) + " + VAT per member/ monthly", 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    disabled: $setup.totalMember <= 1 ? true : false,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleTotalMember('desc')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-minus-circle",
                        variant: "tonal"
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createElementVNode("h4", null, _toDisplayString($setup.totalMember), 1),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.handleTotalMember('inc')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-plus-circle",
                        variant: "tonal"
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h5", null, "£" + _toDisplayString($setup.membershipPrice), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", null, "£" + _toDisplayString($setup.subTotal), 1),
                  _hoisted_14
                ])
              ]),
              _hoisted_15,
              _createVNode(_component_v_btn, {
                class: "button button-orange w-full",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.initializeStripePayment(false, false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("next")
                ]),
                _: 1
              }),
              _hoisted_16
            ]),
            _hoisted_17
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClickBackButton"]))
    : (_openBlock(), _createBlock(_component_commonDialog, {
        key: 1,
        modelValue: $setup.isShowHomeownersWelcome,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.isShowHomeownersWelcome) = $event)),
        HeaderTittle: "Subscription Plan",
        title: `Welcome To iknowa ${$setup.user?.firstName}!`,
        description: "Explore the platform, we’ve a lot of amazing features for you in iknowa! Feel free \nto go around and check all the things we have made for you.",
        onClickBackButton: $setup.onClickToggleHomeownerWorkstation,
        className: ['carousel__dialog', 'subplan_modal']
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                  _hoisted_20
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                  _hoisted_21
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                  _hoisted_22
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                  _hoisted_23
                ]),
                _hoisted_24,
                _hoisted_25
              ])
            ]),
            _hoisted_26
          ]),
          _createVNode(_component_v_divider, {
            color: "info",
            class: "mt-6 mb-10"
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "button button-orange",
                    size: "large",
                    block: "",
                    onClick: $setup.onClickContinueSubscription
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Continue to SUBSCRIPTION ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "button",
                    size: "large",
                    variant: "plain",
                    block: "",
                    onClick: $setup.onClickMoveToDashboard
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" close ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onClickBackButton"]))
}